import { render, staticRenderFns } from "./member.vue?vue&type=template&id=8321dbae&scoped=true&"
import script from "./member.vue?vue&type=script&lang=js&"
export * from "./member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8321dbae",
  null
  
)

export default component.exports